import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MyHttpClient } from '../../http-client.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class HostGeneralInfoService {

    constructor(private http: MyHttpClient) { }

    server = `${environment.server}`;
    hostVehicleDetails = this.server + '/api/getHostVehicleDetails';
    getHostVehicleDetails(id: string) {
        return this.http.get(this.hostVehicleDetails + '/' + id).pipe(catchError(this.handleError));
    }

    getReferralSummary(profileId: string) {
        return this.http.get(`${this.server}/api/pool-manager/profiles/${profileId}/referrals/summary`).pipe(catchError(this.handleError));
    }

    getHoprMetrics(profileId: string) {
        return this.http.get(`${this.server}/api/svo/captain/hopr/metrics/${profileId}`).pipe(catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(error);
    }
}
